import { render, staticRenderFns } from "./EvaluationPanelVue.vue?vue&type=template&id=b677b054&scoped=true&"
import script from "./EvaluationPanelVue.vue?vue&type=script&lang=js&"
export * from "./EvaluationPanelVue.vue?vue&type=script&lang=js&"
import style0 from "./EvaluationPanelVue.vue?vue&type=style&index=0&id=b677b054&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b677b054",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
installComponents(component, {VBtn})
